import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
  OnInit,
} from '@angular/core';
import { CompanyRoles } from '../_models/company.model';
import { DataPersistenceService } from '../services/data-persistence/data-persistence.service';
import { EmpresaRoles } from '../_models/empresa.model';

/**
 * Directiva que oculta elementos del DOM basándose en los roles del usuario.
 * A diferencia de hasRoles, que deshabilita y muestra tooltip, esta directiva
 * oculta completamente el elemento.
 * 
 * Uso:
 * - *hideElements="['canShowData']" - Oculta cuando el usuario NO tiene el rol
 * - *hideElements.inverted="['canShowData']" - Oculta cuando el usuario SÍ tiene el rol
 */
@Directive({
  selector: '[hideElements]',
  standalone: true,
})
export class HideElementsDirective implements OnInit {
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private dataPersistenceService = inject(DataPersistenceService);

  @Input('hideElements') roleKeys: (keyof EmpresaRoles)[] = [];
  
  /**
   * Si es true, invierte la lógica: oculta cuando el usuario SÍ tiene el rol
   * Si es false (default), oculta cuando el usuario NO tiene el rol
   */
  @Input() hideElementsInverted: boolean = false;

  private userRoles: EmpresaRoles = {
    canModificaConfiguracion: false,
    canAgregarSociosDeNegocio: false,
    canCrearYEditarContactos: false,
    canVerInfoRiesgo: false,
    canSolicitarInfoRiesgo: false,
    canMonitorearInfoRiesgo: false,
    canAsignarBandera: false,
    canAsignarEtiqueta: false,
    canEditarFicha: false,
    canModificarEstado: false,
    canVerTransacciones: false,
    canModificarEstadoDocumentalFicha: false,
    canComentarEnBitacora: false
  };

  ngOnInit() {
    this.userRoles = this.dataPersistenceService.getRoles();
    
    // Verificar si el usuario tiene al menos uno de los roles requeridos
    const hasAnyRole = this.roleKeys.some((key) => this.userRoles[key]);
    
    // Determinar si debemos mostrar u ocultar el elemento
    // Si inverted es false: mostrar solo si tiene el rol (hasAnyRole = true)
    // Si inverted es true: mostrar solo si NO tiene el rol (hasAnyRole = false)
    const shouldShow = this.hideElementsInverted ? !hasAnyRole : hasAnyRole;

    this.viewContainer.clear();
    
    if (shouldShow) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    // Si no debe mostrar, el viewContainer queda vacío (elemento oculto)
  }
}
